/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
import ApiClient from "../api-client/apiClient";
// @ts-ignore
import {
  getAccessToken,
  setAccessToken,
  setAuthorizationToken,
} from "../auth/index";
// @ts-ignore

import axios from "axios";
import {
  handleIsLoading,
  handleListing,
  handleLoading,
} from "../store/general";
import { loginFailed, loginSuccess } from "../store/Auth/user";
import { toast } from "react-toastify";
// filepath: /home/nitinb/Desktop/my_projects/Helios/react_changes19 (1)/react/src/actions/user.tsx

const apiUrl = process.env.REACT_APP_API_URL;
const version = process.env.REACT_APP_API_VERSION;

/**
 * User login action
 * @param {any} data - User credentials for login
 * @param {Function} callback - Callback function to handle login response
 */
export const userLogin = (data: any, callback: any) => {
  return async (dispatch: any) => {
    try {
      dispatch(handleLoading(true));
      const response: any = await ApiClient.post(
        `${apiUrl}${version}/auth/login`,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(loginSuccess(response));
        // Set the token locally for authentication
        setAccessToken(response?.token);
        setAuthorizationToken(axios, response?.token);
        return callback(response);
      }
    } catch (error: any) {
      toast.error(error?.data?.message);
      callback(error);
    } finally {
      dispatch(handleLoading(false));
    }
  };
};

/**
 * User logout action
 * @param {Function} callback - Callback function to handle logout response
 */
export const userLogout = (callback: any) => {
  return async (dispatch: any) => {
    try {
      dispatch(handleLoading(true));
      const response: any = await ApiClient.post(
        `${apiUrl}${version}/auth/logout`,
        {},
        dispatch
      );
      if (response.status === 200 || response.status === 201) {
        localStorage.clear(); // Clears local storage on logout
        dispatch(handleLoading(false));
        return callback(response);
      }
    } catch (error: any) {
      toast.error(error?.data?.message);
      callback(error);
    } finally {
      dispatch(handleLoading(false));
    }
  };
};

/**
 * Reset user password action
 * @param {any} data - User email for password reset
 * @param {Function} callback - Callback function to handle response
 */
export const forgotPassword = (data: any, callback: any) => {
  return async (dispatch: any) => {
    try {
      dispatch(handleLoading(true));
      const response: any = await ApiClient.post(
        `${apiUrl}${version}/auth/forgot-password`,
        data
      );
      if (response.status === 200 || response.status === 201) {
        toast.success(response.message);
        dispatch(handleLoading(false));
        return callback(response);
      }
    } catch (error) {
      dispatch(handleLoading(false));
      toast.error(error?.response?.message);
      callback(error);
    } finally {
      dispatch(handleLoading(false));
    }
  };
};

/**
 * Change user password action (after receiving a reset link)
 * @param {any} data - New password details
 * @param {Function} callback - Callback function to handle response
 */
export const changePassword = (data: any, callback: any) => {
  return async (dispatch: any) => {
    try {
      dispatch(handleLoading(true));
      const response: any = await ApiClient.post(
        `${apiUrl}${version}/auth/reset-password`,
        data,
        dispatch
      );
      if (response.status === 200 || response.status === 201) {
        toast.success(response.message);
        dispatch(handleLoading(false));
        return callback(response);
      }
    } catch (error) {
      toast.error(error?.data?.message);
      dispatch(handleLoading(false));
      callback(error);
    } finally {
      dispatch(handleLoading(false));
    }
  };
};

/**
 * Change password after login
 * @param {any} data - Password change request details
 * @param {Function} callback - Callback function to handle response
 */
export const changeAccountPassword = (data: any, callback: any) => {
  return async (dispatch: any) => {
    dispatch(handleLoading(true));
    try {
      const response: any = await ApiClient.patch(
        `${apiUrl}${version}/auth/change-password`,
        data,
        dispatch
      );
      if (response.status === 200 || response.status === 201) {
        toast.success(response.message);
        dispatch(handleLoading(false));
        return callback(response);
      }
    } catch (error) {
      toast.error(error?.data?.message);
      dispatch(handleLoading(false));
      callback(error);
    } finally {
      dispatch(handleLoading(false));
    }
  };
};

/**
 * Fetch user profile details
 * @param {Function} [callback] - Optional callback function
 */
export const checkuser = (callback?: any) => {
  return async (dispatch: any) => {
    try {
      dispatch(handleLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/user/my-profile`,
        {},
        dispatch
      );

      dispatch(handleLoading(false));
      if (response.status === 200) {
        const actionData: any = {
          user: response?.user,
        };
        dispatch(loginSuccess(actionData));
        return callback?.(response);
      }
    } catch (error) {
      if (error) {
        dispatch(loginFailed(error));
        callback(error);
      }
    } finally {
      dispatch(handleLoading(false));
    }
  };
};

/**
 * Check user password
 * @param {any} data - check user password
 * @param {Function} callback - Callback function to handle response
 */
// export const check_password_token = (data: any, callback: any) => {
//   return (dispatch: any) => {
//     dispatch({ type: "ISLOADING", data: true });
//     ApiClient.get(
//       `${apiUrl}/auth/check-password-token/${data.token}`,
//       dispatch
//     ).then((response: any) => {
//       dispatch({ type: "ISLOADING", data: false });

//       if (response.messageID === 200) {
//         // toast.success(response.message);
//         dispatch({ type: "PASSWORDTOKEN", data: response.data });
//         // return callback(response);
//       } else if (response.messageID === 404) {
//         // toast.warn(response.message);
//         // return callback(response);
//       } else {
//         // toast.error(response.message);
//       }
//     });
//   };
// };

/**
 * Logout user and clear session data
 * @param {any} data - Logout request data
 * @param {Function} callback - Callback function to handle response
 */
export const logout = (data: any, callback: any) => {
  return (dispatch: any) => {
    dispatch({ type: "ISLOADING", data: true });

    localStorage.setItem("LOGOUT", JSON.stringify(true));
    ApiClient.get(`${apiUrl}/auth/logout`, data, dispatch).then(
      (response: any) => {
        dispatch({ type: "ISLOADING", data: false });

        if (response.messageID === 200) {
          dispatch({ type: "LOGOUT", data: {} });
          dispatch({ type: "DETAILS_GROUP", data: {} });
          return callback(response);
        } else if (response.messageID === 404) {
          return callback(response);
        } else {
          dispatch({ type: "LOGOUT", data: {} });
        }
      }
    );
  };
};

/**
 * Manage application loading state
 * @param {boolean} flag - Loading state flag
 */
export const loader = (flag: any) => {
  return (dispatch: any) => {
    dispatch({ type: "ISLOADING", data: flag });
  };
};

/**
 * Manage application activity state
 * @param {boolean} flag - Loading state flag
 */
export const set_active_tab = (tab: any) => {
  return (dispatch: any) => {
    dispatch({ type: "SET_ACTIVE_TAB", data: tab });
  };
};

// --------------------------------------------------Data Elements API's----------------------------------------

/**
 * Fetch list of data elements by organization id used in the data entry for selecting organzations and getting the data elements
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const dataElementsOrgIdListAction =
  ({ id, ...restParams }: any, callback: (response: any) => void) =>
  async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/user/organization/data-elements/${id}`,
        restParams,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Fetch list of Data Element by organization Id
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const userDataElementListById =
  (data: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    dispatch(handleIsLoading(true));
    try {
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/user/organization/data-elements`,
        data,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

// -----------------------------------Organization API's-----------------------------------------------

/**
 * Fetch list of organizations
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const UserOrganizationListAction =
  (params: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");

    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/user/organizations`,
        params,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Fetch organization by its ID
 * @param {Function} callback - Callback function to handle response
 */
export const getUserOrganizationById =
  (organizationId: any, callback: (response: any) => void) =>
  async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/user/organization/${organizationId}`,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

/**
 * Fetch user by its ID
 * @param {Function} callback - Callback function to handle response
 */
export const getOrganizationByUserId =
  (userId: any, callback: (response: any) => void) => async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      const response: any = await ApiClient.get(
        `${apiUrl}${version}/user/get-user-organizations/${userId}`,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

// -------------------------------------- User API--------------------------------------------------

// --------------------------------submissions---------------------------------------

/**
 * Create a new Data Submissions/ Data Entry
 * @param {any} data - User details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const createDataEntryForm = (data: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    dispatch(handleIsLoading(true));
    dispatch(handleListing(true));
    try {
      const response: any = await ApiClient.post(
        // `${apiUrl}${version}/user/data-submission`,
        `${apiUrl}${version}/user/update/data-submission`,
        data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message || "Data entry created successfully");
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      toast.error(error?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * update a  budget
 * @param {any} data - budget details to be sent in the request body
 * @param {Function} callback - Callback function to handle API response
 * @returns {Function} - Redux Thunk function
 */

export const updateDataEntryForm = (payload: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    const { id, roleId, ...data } = payload;
    dispatch(handleIsLoading(true));
    dispatch(handleListing(true));
    let baseUrl = `/user/data-submission/${id}`;
    if ([1, 2, 3].includes(roleId)) {
      baseUrl = `/admin/data-submission/${id}`;
    }
    try {
      const response: any = await ApiClient.patch(
        `${apiUrl}${version}${baseUrl}`,
        data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message);
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      toast.error(error?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};

/**
 * Fetch list of users
 * @param {any} data - Filters for fetching user list
 * @param {Function} callback - Callback function to handle response
 */
export const leaderUserListAction = (params: any, callback: any) => {
  return async (dispatch: any) => {
    const tokenRaw: any = getAccessToken();

    try {
      dispatch(handleIsLoading(true));
      if (tokenRaw) {
        const response: any = await ApiClient.get(
          `${apiUrl}${version}/leader/organization/users`,
          params,
          dispatch
        );
        if (response.status === 200) {
          callback(response);
          dispatch(handleIsLoading(false));
        }
      }
    } catch (err) {
      if (err) {
        dispatch(handleIsLoading(false));
        callback(err);
        toast.error(err?.response?.message);
      }
    } finally {
      dispatch(handleIsLoading(false));
    }
  };
};

/**
 * Fetch list of users
 * @param {any} data - Filters for fetching user list
 * @param {Function} callback - Callback function to handle response
 */
export const leaderUserListSpecificOrgAction = (
  payload: { id: any; [key: string]: any },
  callback: any
) => {
  return async (dispatch: any) => {
    const tokenRaw: any = getAccessToken();
    const { id, ...params } = payload;

    try {
      dispatch(handleIsLoading(true));
      if (tokenRaw) {
        const response: any = await ApiClient.get(
          `${apiUrl}${version}/leader/organization/users/${id}`,
          params,
          dispatch
        );
        if (response.status === 200) {
          callback(response);
        }
      }
    } catch (err) {
      if (err) {
        callback(err);
        toast.error(err?.response?.message);
      }
    } finally {
      dispatch(handleIsLoading(false));
    }
  };
};

// ------------------------------------------Submission---------------------------------------

/**
 * Fetch list of submissions
 * @param {any} params - Query parameters
 * @param {Function} callback - Callback function to handle response
 */
export const submissionListAction =
  (requestParams: any, callback: (response: any) => void) =>
  async (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;
    const {
      params,
      id,
      organizationId,
      startDate,
      endDate,
      currentMonth,
      thisMonth,
    } = requestParams;
    let endPoint = null;
    if ([2, 3].includes(id)) {
      endPoint = "/leader/data-submission";
    } else {
      endPoint = "/user/submission-list";
    }
    if (!token) return console.error("No access token available");
    try {
      dispatch(handleIsLoading(true));
      // Build query params dynamically
      const queryParams: any = { ...params };
      if (organizationId) queryParams.organizationId = organizationId;
      if (startDate) queryParams.startDate = startDate;
      if (endDate) queryParams.endDate = endDate;
      if (currentMonth) queryParams.currentMonth = currentMonth;
      if (thisMonth) queryParams.thisMonth = thisMonth;

      const response: any = await ApiClient.get(
        `${apiUrl}${version}${endPoint}`,
        queryParams,
        dispatch
      );
      callback(response);
    } catch (error) {
      toast.error(error?.response?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
    }
  };

//--------------------------------------------Admin Requests-----------------------------------------------

export const acceptDataEntryRequests = (payload: any, callback: any) => {
  // Send a POST request to create a new user
  return async (dispatch: any) => {
    const { id, ...data } = payload;
    dispatch(handleIsLoading(true));
    dispatch(handleListing(true));
    try {
      const response: any = await ApiClient.patch(
        `${apiUrl}${version}/admin/submission/request/approve/${id}`,
        data
      );
      // Check if the request was successful
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.message);
        callback(response); // Call callback with response
      }
    } catch (error: any) {
      // Handle API errors and display appropriate error messages
      toast.error(error?.data?.message);
      callback(error);
    } finally {
      dispatch(handleIsLoading(false));
      dispatch(handleListing(false));
    }
  };
};
